const scriptLoaders = {};

export default function getScript(url, callback) {
  const isExist = document.querySelector(`script[src="${url}"]`);
  if (isExist) {
    // 存在正在加载的脚本
    if (scriptLoaders[url]) {
      scriptLoaders[url].push(callback);

      // clear 给react使用，避免callback在卸载时执行
      return () => {
        // 删除callback
        scriptLoaders[url] = scriptLoaders[url]?.filter(
          (cb) => cb !== callback
        );
      };
    }
    callback();

    // 空clear方法
    return () => {};
  }
  const script = document.createElement("script");
  script.type = "text/javascript";
  scriptLoaders[url] = [callback];
  script.onload = () => {
    const callbacks = scriptLoaders[url];
    if (callbacks) {
      callbacks.forEach((cb) => cb());
    }
    // 执行完清空
    scriptLoaders[url] = null;
  };

  script.onerror = () => {
    //失败清空
    scriptLoaders[url] = null;
  };

  script.src = url;
  const head = document.head || document.head.getElementsByTagName("head")[0];
  head.appendChild(script);

  // clear 给react使用，避免callback在卸载时执行
  return () => {
    // 删除callback
    scriptLoaders[url] = scriptLoaders[url]?.filter((cb) => cb !== callback);
  };
}
